'use client';

import { useTotals } from '@/components/product-selection/hooks/useTotals';
import { centsToDollarsAndCents } from '@/helpers/currencyUtils/helper';

export const TrialSubscriptionSavings = () => {
  const { trialDiscountTotalWithDermatologyConsultationAndSAndH } = useTotals();

  return centsToDollarsAndCents(
    trialDiscountTotalWithDermatologyConsultationAndSAndH,
  );
};
